module.exports = __webpack_public_path__ + "img/boben_bobocoin.gm.fbe6c58.png";